import { useEffect } from "react";
import Link from "next/link";
import { acknowledgeConsentNotice, exposeConsentNotice, openConsentPreferences } from "./controller";
import { useConsentSnapshot } from "./hooks";
export function USConsentNotice() {
  const {
    noticeVisible
  } = useConsentSnapshot();
  useEffect(() => {
    if (noticeVisible) exposeConsentNotice();
  }, [noticeVisible]);
  if (!noticeVisible) return null;
  return <section id="ouster-us-notice" aria-label="Cookie notice" data-lenis-prevent>
      <p>
        We and our vendors use cookies and similar technologies to measure performance, support marketing, manage
        security, and improve our site. We may share the information we collect with analytics and advertising partners.
        You can opt out of the sale or sharing of your personal information for targeted advertising by clicking Manage
        Preferences. By continuing to use our website, you agree to our{" "}
        <Link href="/terms-of-use" prefetch={false}>
          Terms of Use
        </Link>{" "}
        and acknowledge our{" "}
        <Link href="/privacy-policy" prefetch={false}>
          Privacy Policy
        </Link>
        .
      </p>
      <button type="button" className="ouster-manage-preferences" data-ouster-consent-control onClick={openConsentPreferences}>
        Manage Preferences
      </button>
      <button type="button" className="ouster-close-notice" data-ouster-consent-control aria-label="Close cookie notice" onClick={() => acknowledgeConsentNotice("close")}>
        <span aria-hidden="true">×</span>
      </button>
    </section>;
}